var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon-pin-angle-fill',{staticClass:"pin-icon",attrs:{"color":_vm.isPinned ? '#E2037E' : '#A4A5A5'}})}
var staticRenderFns = []

export { render, staticRenderFns }